import React from "react";
import { useNavigate } from "react-router-dom";

const AbdomenCorePT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .core-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #ecfeff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .core-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .core-hero {
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          padding: 28px;
          border-radius: 28px;
          background: linear-gradient(125deg, rgba(34, 197, 94, 0.12), rgba(59, 130, 246, 0.05));
          margin-bottom: 32px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .core-hero {
            grid-template-columns: 1fr;
          }
        }

        .core-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(34, 197, 94, 0.2);
          color: #166534;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .core-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #16a34a;
        }

        .core-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 8px;
        }

        .core-subtitle {
          font-size: 15px;
          max-width: 540px;
          color: #374151;
        }

        .core-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .core-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .core-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .core-btnPrimary,
        .core-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .core-btnPrimary {
          background: #22c55e;
          color: #022c22;
          box-shadow: 0 9px 22px rgba(34, 197, 94, 0.35);
        }

        .core-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(34, 197, 94, 0.45);
        }

        .core-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .core-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .core-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .core-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.25);
        }

        /* STRIPES */
        .core-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .core-sectionTitle {
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .core-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .core-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .core-flexCol {
          flex: 1 1 260px;
        }

        .core-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .core-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .core-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .core-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #22c55e;
          flex-shrink: 0;
        }

        /* INFO CARDS */
        .core-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .core-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .core-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .core-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .core-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .core-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .core-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .core-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .core-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .core-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .core-banner img {
            height: 260px;
          }
        }

        .core-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.8), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .core-bannerText {
          color: #e0f2fe;
          font-size: 15px;
          max-width: 420px;
        }

        .core-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .core-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .core-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .core-bannerButtons .secondary {
          background: rgba(255, 255, 255, 0.18);
          color: #f9fafb;
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        /* BOTTOM WARNING */
        .core-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .core-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .core-bottomText strong {
          color: #fef9c3;
        }

        .core-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .core-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .core-bottomActions .primary {
          background: #22c55e;
          color: #022c22;
        }

        .core-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .core-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="core-page">
        <div className="core-inner">
          {/* HERO */}
          <section className="core-hero">
            <div>
              <div className="core-tag">
                <span className="core-tagDot" />
                Abdomen / Core Support
              </div>
              <h1 className="core-title">
                Build a stronger, calmer core for everyday movement and support.
              </h1>
              <p className="core-subtitle">
                The rectus abdominis, obliques, and transverse abdominis work together to support your spine,
                stabilize your trunk, and help you twist, bend, and lift. When they&apos;re weak or irritated,
                even simple tasks can feel harder.
              </p>

              <div className="core-chips">
                <span className="core-chip">Core weakness or fatigue</span>
                <span className="core-chip">Posture strain</span>
                <span className="core-chip">Difficulty with bending or lifting</span>
                <span className="core-chip">Post-surgery stiffness (with medical clearance)</span>
              </div>

              <div className="core-ctaRow">
                <button
                  className="core-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a core-focused visit →
                </button>
                <button
                  className="core-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="core-heroImgWrap">
              <img
                src="/content/abdomen-core/abdomen_core_hero.png"
                alt="Therapist guiding a patient through core activation"
                className="core-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="core-stripe">
            <div className="core-sectionTitle">What can go wrong in the abdomen / core?</div>
            <p className="core-sectionSubtitle">
              Core muscles don&apos;t just make “abs.” They help stabilize your spine, support breathing,
              and control twisting and bending.
            </p>

            <div className="core-flexRow">
              <div className="core-flexCol">
                <ul className="core-list">
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Rectus abdominis strain:</strong> soreness across the front abs with
                      sit-ups, coughing, or sudden movement.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Oblique tightness or weakness:</strong> discomfort along the sides of the torso
                      when twisting or reaching.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Deep core under-activation:</strong> transverse abdominis not engaging well,
                      leaving your back to do too much.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Postural fatigue:</strong> feeling like you can&apos;t sit or stand upright
                      for long without “slumping.”
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Post-surgical stiffness:</strong> after medical clearance, lingering tightness
                      around scar or incision areas.
                    </span>
                  </li>
                </ul>

                <div className="core-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="core-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your core symptoms fit →
                  </button>
                  <button
                    className="core-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="core-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/abdomen-core/abdomen_core_assessment.jpg"
                  alt="Therapist assessing abdominal and core muscles"
                  className="core-img"
                />
              </div>
            </div>

            <div className="core-cardGrid">
              <div className="core-card">
                <div className="core-cardTitle">Rectus Abdominis</div>
                <div className="core-cardText">
                  Front “six-pack” muscle that helps you bend forward and supports trunk stability.
                </div>
              </div>
              <div className="core-card">
                <div className="core-cardTitle">Obliques</div>
                <div className="core-cardText">
                  Side muscles that help you twist, side-bend, and stabilize the ribs and pelvis.
                </div>
              </div>
              <div className="core-card">
                <div className="core-cardTitle">Transverse Abdominis</div>
                <div className="core-cardText">
                  Deep &quot;corset&quot; muscle that gently hugs the spine and helps with deep stability.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="core-stripe">
            <div className="core-flexRow">
              <div className="core-flexCol">
                <img
                  src="/content/abdomen-core/abdomen_core_training.png"
                  alt="Patient practicing guided core exercises"
                  className="core-img"
                />
              </div>

              <div className="core-flexCol">
                <div className="core-sectionTitle">How physical therapy supports your core</div>
                <p className="core-sectionSubtitle">
                  We build a foundation first, then layer in strength and real-life movement.
                </p>

                <ul className="core-list">
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Deep core activation:</strong> learning how to gently turn on your transverse
                      abdominis without holding your breath.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Oblique and rectus coordination:</strong> training the front and side muscles
                      to share the load during twisting and bending.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Breathing mechanics:</strong> using the diaphragm and rib motion to take
                      pressure off the low back and neck.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Posture and movement coaching:</strong> simple tweaks to sitting, lifting,
                      and walking so your core can help more.
                    </span>
                  </li>
                  <li>
                    <span className="core-bullet" />
                    <span>
                      <strong>Graded strengthening:</strong> progressing from easy floor-based work to
                      standing, lifting, and dynamic tasks.
                    </span>
                  </li>
                </ul>

                <div className="core-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="core-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start core-focused therapy →
                  </button>
                  <button
                    className="core-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="core-stripe">
            <div className="core-sectionTitle">What an abdomen / core session looks like</div>

            <div className="core-flexRow">
              <div className="core-flexCol">
                <img
                  src="/content/abdomen-core/abdomen_core_exercises.png"
                  alt="Therapist guiding core and trunk exercises"
                  className="core-img"
                />
              </div>

              <div className="core-flexCol">
                <div className="core-timeline">
                  <div className="core-step">
                    <div className="core-stepLabel">1. Your story</div>
                    <div className="core-stepText">
                      Where do you feel strain or weakness? What tasks make it worse? What do you want to get back to?
                    </div>
                  </div>
                  <div className="core-step">
                    <div className="core-stepLabel">2. Motion & strength check</div>
                    <div className="core-stepText">
                      We look at trunk motion, control, and how your core supports your spine with movement.
                    </div>
                  </div>
                  <div className="core-step">
                    <div className="core-stepLabel">3. Hands-on and guided work</div>
                    <div className="core-stepText">
                      Gentle techniques and specific drills to help muscles activate and relax appropriately.
                    </div>
                  </div>
                  <div className="core-step">
                    <div className="core-stepLabel">4. Simple home plan</div>
                    <div className="core-stepText">
                      A small set of repeatable core moves and posture cues you can actually remember.
                    </div>
                  </div>
                </div>

                <div className="core-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="core-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a core evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="core-stripe">
            <div className="core-banner">
              <img
                src="/content/abdomen-core/abdomen_core_banner.png"
                alt="Calm physical therapy clinic for core and trunk rehab"
              />
              <div className="core-bannerOverlay">
                <div className="core-bannerText">
                  Core-focused sessions happen in a calm, one-on-one setting where we can match the plan
                  to your exact goals—whether that&apos;s daily comfort, sport, or work demands.
                </div>
                <div className="core-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule abdomen / core visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="core-stripe">
            <div className="core-bottomStrip">
              <div className="core-bottomText">
                If you ever notice strong, sudden abdominal pain, fever, vomiting, changes in bowel or bladder,
                or pain that feels worrying or different than muscle strain,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can support your
                recovery once serious causes have been ruled out.
              </div>
              <div className="core-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule core PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default AbdomenCorePT;
